import { MeterBarSegment } from '../../shared/components/meter-bar-segment/MeterBarSegment.js';
import { useMultiMeterBarHighlightedSegments } from '../hooks/store/selectors.js';
import { useSetTooltipContent } from '../hooks/store/use-set-tooltip-content.js';

interface MultiMeterBarChartSegmentProps {
  segmentId: string;
  segmentColor: string;
  segmentWidth: number;
  previousSegmentsWidth: number;
}

export const MultiMeterBarChartSegment = (
  props: MultiMeterBarChartSegmentProps,
) => {
  const { previousSegmentsWidth, segmentColor, segmentWidth, segmentId } =
    props;
  const highlightedSegments = useMultiMeterBarHighlightedSegments();
  const highlightedSegmentIds = highlightedSegments?.map((s) => s.id);
  const isHighlighted =
    !highlightedSegments || highlightedSegmentIds?.includes(segmentId);

  const { setTooltipContent } = useSetTooltipContent();

  return (
    <MeterBarSegment
      color={segmentColor}
      width={segmentWidth}
      highlighted={isHighlighted}
      start={previousSegmentsWidth}
      onMouseEnter={() => setTooltipContent(segmentId)}
      onMouseMove={() => setTooltipContent(segmentId)}
    />
  );
};

MultiMeterBarChartSegment['displayName'] = 'MultiMeterBarChartSegment';
